import { EditSimilar, FindSimilar, FindSimilarSemantic } from './requests';
import { FIND_SIMILAR_GENERAL_SIMILARITY_THRESHOLD } from '../config';
import { setErrMsg, setSuccessMsg } from '../redux/actions/snackbarActions';

export const FindSimilarTextUtil = async (
  sectionIdParam,
  model,
  tuid,
  text,
  textType,
  textSections,
  rule = null,
  limit = null
) => {
  let sectionForQuery = textSections.length > 0 ? textSections[0] : 'none';
  if (sectionIdParam) {
    sectionForQuery = sectionIdParam;
  }
  const reqData = {
    model,
    text,
    threshold: FIND_SIMILAR_GENERAL_SIMILARITY_THRESHOLD,
    section: sectionForQuery,
    text_type: textType,
    tuid,
    increment: 0.01,
  };
  if (limit) {
    reqData.limit = limit;
  }
  if (rule) {
    reqData.rule = rule;
  }
  return FindSimilar(reqData)
    .then((data) => data)
    .catch((err) => {
      throw Error(`Failed to find similar text with error: ${err}`);
    });
};

export const findSimilarText = async (
  addSimilarTextData,
  dispatch,
  tuid,
  text,
  textType,
  textSections,
  sectionIdParam,
  modelId,
  ruleParam
) => {
  const data = await FindSimilarTextUtil(
    sectionIdParam,
    modelId,
    tuid,
    text,
    textType,
    textSections,
    ruleParam
  ).catch((err) => {
    console.error(err);
    return null;
  });

  if (data) {
    dispatch(setSuccessMsg(`Found ${data.length} similar texts`));
    addSimilarTextData(data);
  } else {
    dispatch(setErrMsg('An error occurred'));
  }
};

export const EditSimilarTextUtil = async (
  sectionIdParam,
  model,
  tuid,
  text,
  editedText,
  textType,
  textSections,
  rule = null,
  limit = null
) => {
  let sectionForQuery = textSections.length > 0 ? textSections[0] : 'none';
  if (sectionIdParam) {
    sectionForQuery = sectionIdParam;
  }
  const reqData = {
    model,
    text,
    edited_text: editedText,
    threshold: FIND_SIMILAR_GENERAL_SIMILARITY_THRESHOLD,
    section: sectionForQuery,
    text_type: textType,
    tuid,
  };
  if (limit) {
    reqData.limit = limit;
  }
  if (rule) {
    reqData.rule = rule;
  }
  return EditSimilar(reqData)
    .then((data) => data)
    .catch((err) => {
      throw Error(`Failed to edit similar text with error: ${err}`);
    });
};

export const SemanticFindSimilarTextUtil = async (
  query,
  limit = null,
  rule = null,
  autoEdit = false,
  model = null,
  textResultTypes = null,
  sections = null
) => {
  const reqData = {
    query,
  };
  if (limit) {
    reqData.limit = limit;
  }
  if (rule) {
    reqData.rule = rule;
  }
  if (autoEdit) {
    reqData.autoEdit = autoEdit;
  }
  if (model) {
    reqData.model = model;
  }
  if (textResultTypes && textResultTypes.length > 0) {
    reqData.textResultTypes = textResultTypes;
  }
  if (sections && sections.length > 0) {
    reqData.sections = sections;
  }
  return FindSimilarSemantic(reqData)
    .then((data) => data)
    .catch((err) => {
      throw Error(`Failed to perform semantic search with error: ${err}`);
    });
};
